module.exports = __webpack_public_path__ + "fonts/ed311a0a73adbe968d0379ca99245d42.txt";